"use client";
import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import "./header.scss";
import { switchLanguage, openTarget } from "@/app/utils/Common";
import { GET_HEADER } from "./request/query";
import { getHeader } from "./request/requestList";
import {
  LANGCODE_CT,
  LANGCODE_EN,
  LANGUAGE,
  str2LangCode,
  useLanguage,
} from "@/app/utils/LanguageContext";
import {
  redirectPage,
  theme,
  getAssetPrefix,
  getLoginInfo,
} from "./utils/Common";
import { useMediaQuery } from "@mui/material";
import cookie from "react-cookies";
import "./comm.scss";
import { LANGTYPE_EN } from "./utils/LanguageContext";

const Header = () => {
  const { state: lang } = useLanguage();
  const { t, langCode } = lang;
  const [headerData, setHeader] = useState<any>();
  const [salut, setSalut] = useState<string>("");
  const [searchTxt, setSearchTxt] = useState<string>("");
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showDisplayName, setShowDisplayName] = useState("");
  const assetPrefix = getAssetPrefix();
  const [homepage, sethomepage] = useState("");

  useEffect(() => {
    console.log(lang);
    getHeader({
      path: "/sitecore/content/Sites/JCRW/SiteConfiguration/Header",
      language: lang.langCode,
    })
      .then((res: any) => {
        normalizeMainMenu(res);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  const normalizeMainMenu = (res: any) => {
    console.log("headerData", res?.item);
    const data = res?.item;
    if (data !== null && data !== undefined) {
      setHeader(data);
    }
  };

  const submitSearch = (e?: any) => {
    if (e && e.keyCode != "13") {
      return;
    }
    const searchVlaue = btoa(
      encodeURIComponent(searchTxt.replace(/^\s+/, "").replace(/\s+$/, ""))
    );
    let url = "";
    if (searchVlaue == "") {
      if (langCode === LANGCODE_EN) alert("Please input a search query");
      if (langCode === LANGCODE_CT) alert("請輸入搜尋字串");
    } else {
      if (langCode === LANGCODE_EN)
        url =
          "//search.hkjc.com/english/index.html" + "?g=all&k=" + searchVlaue;
      if (langCode === LANGCODE_CT)
        url =
          "//search.hkjc.com/chinese/index.html" + "?g=all&k=" + searchVlaue;
      window.location.href = url;
    }
  };

  useEffect(() => {
    if (!isMobile) {
      getLoginStatus();
      sethomepage(
        lang.langType === LANGTYPE_EN
          ? window.globalConfig?.LINKED_PAGES?.HOMEPAGEENG
          : window.globalConfig?.LINKED_PAGES?.HOMEPAGECHI
      );
    }
  }, [isMobile]);

  let count = 0;
  const getLoginStatus = () => {
    const isUserProfileLoaded = localStorage.getItem("IsUserProfileLoaded");
    console.log(
      "getLoginInfo getLoginStatus isUserProfileLoaded",
      isUserProfileLoaded
    );
    if (
      count <= 10 &&
      (isUserProfileLoaded == "false" || !isUserProfileLoaded)
    ) {
      console.log("getLoginInfo getLoginStatus count", count);
      setTimeout(() => {
        count++;
        console.log("getLoginInfo getLoginStatus no");
        return getLoginStatus();
      }, 1000);
    } else if (isUserProfileLoaded || count > 10 || WCIPCookie.isLoggedIn()) {
      console.log("getLoginInfo getLoginStatus end");
      refreshGlobalLoginControl();
    }
  };

  const refreshGlobalLoginControl = () => {
    const custProIn = cookie.load("custProIn");
    const { isLogin, displayName } = getLoginInfo(custProIn, langCode);
    setIsLogin(isLogin);
    setShowDisplayName(displayName);
    // console.log(
    //   "getLoginInfo",
    //   isLogin,
    //   displayName,
    //   window.WCIPCookie?.isLoggedIn()
    // );
  };

  return (
    <div style={{ width: isMobile ? "auto" : "1000px" }} id="header">
      <Grid
        spacing={0}
        className="commBContent"
        container
        sx={{
          maxWidth: "1808px",
          margin: "0 auto",
          width: isMobile ? "auto" : "1000px",
          padding: isMobile ? "" : "0 16px",
        }}
      >
        <Grid item lg={3}>
          {langCode === LANGCODE_EN ? (
            <a
              id="logo"
              className="logo_en"
              href={headerData?.LeftLink?.value}
              target={openTarget(headerData?.LeftLinkNewWindow?.value)}
            >
              {headerData?.LeftImage?.value ? (
                <img
                  src={headerData?.LeftImage?.src}
                  alt={headerData?.LeftImage?.alt}
                  id="imgMainLogo"
                />
              ) : (
                <img
                  src={`${assetPrefix}/commonImg/logo_hkjc_e.png`}
                  alt="The Hong Kong Jockey Club"
                  id="imgMainLogo"
                />
              )}
            </a>
          ) : (
            <a
              id="logo"
              className="logo_ch"
              href={headerData?.LeftLink?.value}
              target={openTarget(headerData?.LeftLinkNewWindow?.value)}
            >
              {headerData?.LeftImage?.value ? (
                <img
                  src={headerData?.LeftImage?.src}
                  alt={headerData?.LeftImage?.alt}
                  id="imgMainLogo"
                />
              ) : (
                <img
                  src={`${assetPrefix}/commonImg/logo_hkjc_c.png`}
                  alt="香港賽馬會"
                  id="imgMainLogo"
                />
              )}
            </a>
          )}
        </Grid>
        <Grid
          item
          lg={9}
          sx={{ display: { xs: "none", lg: "block" }, paddingBottom: "8px" }}
        >
          <div id="header_nav" className="nav">
            <div id="topNav">
              <div>
                <input name="searchkey" id="searchkey" type="hidden" />
                {Object.keys(LANGUAGE).map((key: string) => {
                  const code = str2LangCode(key);
                  if (lang.langCode === code) return;
                  return (
                    <>
                      <a href={homepage}>{t("home")}</a>
                      <a onClick={() => switchLanguage(code)} className="lang">
                        {LANGUAGE[code].display}
                      </a>
                    </>
                  );
                })}
                <input
                  maxLength={166}
                  title=""
                  placeholder={t("search")}
                  type="text"
                  name=""
                  id="searchtxt"
                  onChange={(e) => setSearchTxt(e.target.value)}
                  onKeyUp={(e) => submitSearch(e)}
                />
                <input
                  className="iconToggle"
                  type="image"
                  name=""
                  id="searchimg"
                  src={`${assetPrefix}/commonImg/icon_toggle.gif`}
                  alt={t("search")}
                  onClick={() => submitSearch()}
                />
              </div>
              <div id="globalLoginControl">
                <div
                  className="beforelogin"
                  style={{ display: isLogin ? "none" : "" }}
                >
                  <a
                    className="login"
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "login", langCode)}
                  >
                    {t("login")}
                  </a>{" "}
                  /{" "}
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "register", langCode)}
                  >
                    {t("register")}
                  </a>
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "help", langCode)}
                    className="faq"
                  >
                    {t("faq")}
                  </a>
                </div>
                <div
                  className="afterlogin"
                  style={{ display: isLogin ? "" : "none" }}
                >
                  <div className="hkjc_login_message">
                    <span className="hkjc_greeting_name">
                      {t("hi")}
                      {showDisplayName}
                    </span>
                    <a
                      className="logout"
                      href="javascript:;"
                      onClick={(e) => redirectPage(e, "logout", langCode)}
                    >
                      {t("logout")}
                    </a>{" "}
                    /{" "}
                  </div>
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "preference", langCode)}
                  >
                    {t("preference")}
                  </a>
                  <a
                    href="javascript:;"
                    onClick={(e) => redirectPage(e, "help", langCode)}
                    className="faq"
                  >
                    {t("faq")}
                  </a>
                </div>
              </div>
              {/* <div id="ssoDiv"></div> */}
            </div>
            <div id="ewinContainer">
              <a
                className="ewin"
                onClick={(e) => waTracker("header_ewin_home")}
                href={headerData?.RightLink?.value}
                target={openTarget(headerData?.RightLinkNewWindow?.value)}
              >
                <img
                  src={
                    headerData?.RightImage?.src
                      ? headerData?.RightImage?.src
                      : `${assetPrefix}/windImg/icon_ewin.png`
                  }
                  style={{ border: 0, width: 39, height: 40 }}
                  alt={headerData?.RightImage?.alt}
                  id="imgSubLogo"
                />
              </a>
              <a
                onClick={(e) => waTracker("header_ewin_racing")}
                href={headerData?.HRRedirectionLink?.value}
                target={openTarget(headerData?.HRRedirectionNewWindow?.value)}
                id="lblHR"
              >
                {headerData?.HRLabel?.value}
              </a>
              <a
                onClick={(e) => waTracker("header_ewin_football")}
                href={headerData?.FBRedirectionLink?.value}
                target={openTarget(headerData?.FBRedirectionNewWindow?.value)}
                id="lblFB"
              >
                {headerData?.FBLabel?.value}
              </a>
              <a
                onClick={(e) => {
                  waTracker("header_ewin_marksix");
                }}
                href={headerData?.M6RedirectionLink?.value}
                target={openTarget(headerData?.M6RedirectionNewWindow?.value)}
                id="lblM6"
              >
                {headerData?.M6Label?.value}
              </a>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

function waTracker(name: string) {
  console.log("tracker name: ", name);
  // WATracker.trackClickEvent(name)
}

export default Header;
